export type CampaignPostDraftStatusKind =
  | "unsaved_changes"
  | "unpublished_draft"
  | "published"
  | "generated_baseline";

export function getCampaignPostDraftState(input: {
  postDraftKey: string;
  persistedDraftKey: string;
  publishedDraftKey: string;
  hasPublishedDraft: boolean;
  hasPersistedDraft: boolean;
  hasPostDraft: boolean;
  isPostEditable: boolean;
  isSavingDraft: boolean;
  isPublishingDraft: boolean;
}) {
  const hasUnsavedLocalChanges = input.postDraftKey !== input.persistedDraftKey;
  const hasUnpublishedDraft =
    input.hasPersistedDraft && input.persistedDraftKey !== input.publishedDraftKey;
  const hasChangesToSave = input.hasPostDraft && (hasUnsavedLocalChanges || hasUnpublishedDraft);

  return {
    hasUnsavedLocalChanges,
    hasUnpublishedDraft,
    hasChangesToSave,
    statusKind: getCampaignPostDraftStatusKind({
      hasUnsavedLocalChanges,
      hasUnpublishedDraft,
      hasPublishedDraft: input.hasPublishedDraft,
    }),
    canSaveChanges:
      input.isPostEditable &&
      input.hasPostDraft &&
      hasChangesToSave &&
      !input.isSavingDraft &&
      !input.isPublishingDraft,
  };
}

function getCampaignPostDraftStatusKind(input: {
  hasUnsavedLocalChanges: boolean;
  hasUnpublishedDraft: boolean;
  hasPublishedDraft: boolean;
}): CampaignPostDraftStatusKind {
  if (input.hasUnsavedLocalChanges) {
    return "unsaved_changes";
  }

  if (input.hasUnpublishedDraft) {
    return "unpublished_draft";
  }

  if (input.hasPublishedDraft) {
    return "published";
  }

  return "generated_baseline";
}
